import * as _ from 'lodash';

export const isEqual = (oldData: any, newData: any): boolean => {
  return _.isEqual(oldData, newData);
};
